/*********************** Custom JS for Boost AI Search & Discovery  ************************/
jQ(document).ready(function() {
  jQ('.boost-pfs-action-list-wrapper.boost-pfs-action-extend')?.remove();
  let hcSelectorSorting = document.querySelector(".hc-flex-end.boost-pfs-filter-toolbar-item");
  if(hcSelectorSorting) {
    hcSelectorSorting = hcSelectorSorting.parentElement;
    let newDiv = document.createElement("div");
    newDiv.classList.add("layout-change-container");
    newDiv.innerHTML = `<div class="hc-icon-layout-container">
          <svg xmlns="http://www.w3.org/2000/svg" class="hc-icon-layout" data-columns="3" width="26" height="20" viewBox="0 0 26 20" fill="none">
            <g>
              <rect width="6" height="20" fill="#121212"/>
              <rect x="10" width="6" height="20" fill="#121212"/>
              <rect x="20" width="6" height="20" fill="#121212"/>
            <g>
          </svg>
        </div>
        <div class="hc-icon-layout-container">
          <svg xmlns="http://www.w3.org/2000/svg" class="hc-icon-layout" data-columns="4" width="36" height="20" viewBox="0 0 36 20" fill="none">
            <g>
              <rect width="6" height="20" fill="#121212"/>
              <rect x="10" width="6" height="20" fill="#121212"/>
              <rect x="20" width="6" height="20" fill="#121212"/>
              <rect x="30" width="6" height="20" fill="#121212"/>
            </g>
          </svg>
        </div>`;
      hcSelectorSorting.appendChild(newDiv);
      layoutChanges();
   }

  function layoutChanges() {
   if(window.innerWidth > 1099) {
     document.querySelectorAll(".hc-icon-layout-container")?.forEach(item => {
      item?.addEventListener("click", (e) => {
          const svg = item?.querySelector("svg");
          item.previousElementSibling?.querySelector("svg")?.classList.remove("hc-icon-layout-active");
          item.nextElementSibling?.querySelector("svg")?.classList.remove("hc-icon-layout-active");
          svg?.classList.add("hc-icon-layout-active");
          const numberOfColumns = svg?.getAttribute("data-columns");
          const cards = document.querySelectorAll(".boost-pfs-filter-product-item");
          localStorage.setItem("number_of_columns", `${numberOfColumns}`);
      
          function adjustCardStyles() {
            const width = window.innerWidth;
            cards.forEach(card => {
              if (width <= 1099) {
                card.removeAttribute('style');
              } else {
                card.style.width = `${100 / numberOfColumns}%`;
              }
            });
          }
      
          adjustCardStyles();
      
          window.addEventListener('resize', adjustCardStyles);
           cards?.forEach(card => {
           card.style = `width: ${100/numberOfColumns}%;`
         });  
       });
     });
     const localNumberOfColumns = localStorage.getItem("number_of_columns");
     if(localNumberOfColumns) {
       const iconSvg = document.querySelector(`.hc-icon-layout[data-columns='${localNumberOfColumns}']`);
       iconSvg?.parentElement.click();
     } else {
       const iconSvg = document.querySelector(`.hc-icon-layout[data-columns='3']`);
       iconSvg?.parentElement.click();
      }
   }
  }

  function filterAdjustments () {
    const clearAllBtn = document.querySelector(".boost-pfs-filter-mobile-toolbar-right");
    const queryParams = new URLSearchParams(window.location.search);
    const hasQueryParams = Array.from(queryParams.entries()).length > 0;
    let newCancelBtn;
    let cancelBtn = document.querySelector(".hc-button-cancel");
    if(hasQueryParams) {
      if(!cancelBtn && clearAllBtn.children[0]) {
        newCancelBtn = document.createElement("button");
        newCancelBtn.classList.add("hc-button-cancel", "boost-pfs-filter-apply-all-button");
        newCancelBtn.setAttribute("aria-label", "Clear all filters");
        newCancelBtn.textContent = clearAllBtn.children[0].textContent;
        const boostFooter = document.querySelector(".boost-pfs-filter-mobile-footer");
        boostFooter.insertBefore(newCancelBtn, boostFooter.children[0]);
      }
  
      newCancelBtn?.addEventListener("click", () => {
        clearAllBtn.children[0]?.click();
      });
    } else {
      cancelBtn?.remove();
    }
  }

  
  window.addEventListener("resize", layoutChanges);

  document.querySelector(".boost-pfs-filter-tree-mobile-button button")?.addEventListener("click", () => {
    filterAdjustments();
    buttonHeightWrapping();
  });

  window.addEventListener('boost-pfs-change-address-bar', () => {
    buttonHeightWrapping();
    filterAdjustments();
    observerFn();
  });

  function observerFn() {
    const observer = new MutationObserver((mutationsList, observer) => {
      let lastIteration = false;
      for (let i = 0; i < mutationsList.length; i++) {
        const mutation = mutationsList[i];
  
        if (i === mutationsList.length - 1) {
          lastIteration = true;
        }
  
        if (lastIteration) {
          layoutChanges();
          observer.disconnect();
        }
      }
    });
  
    const config = {
      childList: true
    };
  
    observer.observe(document.querySelector(".boost-pfs-filter-products"), config);
  }

  /* Filter buttons (show result and cancel) height on correction */
  document.querySelectorAll(".boost-pfs-filter-option-item")?.forEach(item => {
    item?.addEventListener("click", () => {
      buttonHeightWrapping();
    });
  });

  function buttonHeightWrapping() {
    const btnShowResult = document.querySelector(".boost-pfs-filter-mobile-footer button.boost-pfs-filter-show-result");
    if(btnShowResult.clientHeight > 49) {
      btnShowResult.parentElement.style = "flex-wrap: wrap; flex-direction: column-reverse;";
    }
  }
});

